<section id="editions" class="editions-section">
  <h3>{{ 'EDITIONS.SUGGESTED_TITLE' | translate }}</h3>
  @if (suggestedEditions.length === 0) {
    <p class="empty-hint">{{ 'EDITIONS.EMPTY_HINT' | translate }}</p>
  } @else {
    <div class="editions-grid suggested-grid">
      @for (edition of suggestedEditions; track edition.id) {
        <article class="editions-card active"
          (click)="toggleEdition(edition.id)"
          (keydown.enter)="toggleEdition(edition.id)"
          (keydown.space)="toggleEdition(edition.id)">
          <div class="title-strip" aria-hidden="true">
            <div class="title-main">
              <span class="leading-mark">
                <svg width="7" height="16" viewBox="0 0 7 16" fill="none">
                  <path d="M0 0H1.52174L7 16H5.47826L0 0Z" fill="white" />
                </svg>
              </span>
              <h4>{{ edition.name }}</h4>
            </div>
            <span class="title-tail">
              <svg width="11" height="32" viewBox="0 0 11 32" fill="none">
                <path d="M0 0L11 32H0V0Z" fill="#0066CC" />
              </svg>
            </span>
          </div>

          <div class="card-content">
            <div class="details">
              <div class="term-block">
                <p class="term-label">{{ edition.termLabel || 'Term' }}</p>
                <div class="meta-row">
                  <span class="term-value">{{ edition.term }}</span>
                  <span class="price">{{ formatPrice(edition) }}</span>
                </div>
              </div>
              <a class="learn-more"
                [href]="edition.learnMoreUrl"
                target="_blank"
                rel="noopener noreferrer"
                (click)="$event.stopPropagation()">
                {{ edition.learnMoreLabel }}
              </a>
            </div>
          </div>
        </article>
      }
    </div>
  }

  <div class="all-editions-row">
    <button class="all-editions-toggle" (click)="toggleAllEditions()">
      <svg class="chevron" [class.open]="showAllEditions" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7.5 5L12.5 10L7.5 15" stroke="#232526" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ 'EDITIONS.ALL_EDITIONS' | translate }}</span>
    </button>

    @if (showAllEditions) {
      <div class="editions-grid">
        @for (edition of editions; track edition.id) {
          <article class="editions-card"
            [class.active]="isEditionActive(edition.id)"
            [class.inactive]="!isEditionActive(edition.id)"
            (click)="toggleEdition(edition.id)"
            (keydown.enter)="toggleEdition(edition.id)"
            (keydown.space)="toggleEdition(edition.id)">
            <div class="title-strip" aria-hidden="true">
              <div class="title-main">
                <span class="leading-mark">
                  <svg width="7" height="16" viewBox="0 0 7 16" fill="none">
                    <path d="M0 0H1.52174L7 16H5.47826L0 0Z" fill="white" />
                  </svg>
                </span>
                <h4>{{ edition.name }}</h4>
              </div>
              <span class="title-tail">
                <svg width="11" height="32" viewBox="0 0 11 32" fill="none">
                  <path d="M0 0L11 32H0V0Z" fill="#0066CC" />
                </svg>
              </span>
            </div>

            <div class="card-content">
              <div class="details">
                <div class="term-block">
                  <p class="term-label">{{ edition.termLabel || 'Term' }}</p>
                  <div class="meta-row">
                    <span class="term-value">{{ edition.term }}</span>
                    <span class="price">{{ formatPrice(edition) }}</span>
                  </div>
                </div>
                <a class="learn-more"
                  [href]="edition.learnMoreUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="$event.stopPropagation()">
                  {{ edition.learnMoreLabel }}
                </a>
              </div>
            </div>
          </article>
        }
      </div>
    }
  </div>
</section>
